import {useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {getPatientsWithCriticalData} from '../../actions/adminActions';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { sysCategory } from '../../utils/bpCategory';
import { useSortableTable, SortableTh, personName } from '../SortableTable';
import { formatDateTime } from '../../utils/dateFormat';

const CRITICAL_SORT_COLUMNS = {
    patient: { type: 'name', value: (p) => personName(p?.assigned_patient_id) },
    bp: { type: 'number', value: (p) => p?.telemetaryData?.sys },
    pulse: { type: 'number', value: (p) => p?.telemetaryData?.pul },
    when: { type: 'date', value: (p) => p?.telemetaryData?.ts || p?.dateAdded },
};


const PatientsWithCriticalReadingsAdmin = () => {
  
  const dispatch = useDispatch();

  const {criticalPts} = useSelector(state => state.criticalPatients);


  const tableSort = useSortableTable(criticalPts, { id: 'admin.criticalReadings', columns: CRITICAL_SORT_COLUMNS, defaultSort: { key: 'when', dir: 'desc' } });
  useEffect(() => {
    dispatch(getPatientsWithCriticalData());
  }, [dispatch]);

  const respondedResults = criticalPts && criticalPts.filter(item => item?.notes?.length > 0)
  const countRespondedResult = respondedResults.length;

  const notRespondedResults = criticalPts && criticalPts.filter(a => !a?.notes?.length);
  const countNotRespondedResult = notRespondedResults.length;

  
  let sysBPCategory; //variable to store category of BP
  let color

    function calcSysBpCategory(sys) {
        const c = sysCategory(sys);
        sysBPCategory = c.label;
        color = c.color;
    }

  
  return (
    <div className="shadow-lg bg-white recent-readings-card">
            <div className="row-display">
                <div>
                    <h5 className="title pl-3">Critical Readings</h5>
                    <p> <small className="pl-3">
                            RPM Patient with critical readings during past three days.
                        </small>
                    </p>   
                </div>

                <div>
                    <span style={{color: 'green'}}>{countRespondedResult} Responded</span> &nbsp;&nbsp;
                    <span style={{color: 'red'}}>{countNotRespondedResult} Not Responded</span>
                </div>
            </div>

                    <Table bordered className="text-center">
                        <thead>
                        <tr>
                            <SortableTh sortKey="patient" sort={tableSort}>Patient</SortableTh>
                            <SortableTh sortKey="bp" sort={tableSort} style={{width: '80px'}}>B.P</SortableTh>
                            <SortableTh sortKey="pulse" sort={tableSort} style={{width: '60px'}}>Pulse</SortableTh>
                            <SortableTh sortKey="when" sort={tableSort}>Date & Time</SortableTh>
                            <th>Code & Status</th>
                            <th style={{width: '70px'}}></th>
                        </tr>
                        </thead>
                        <tbody>
                        {tableSort.rows.map((pts, index) => (
                        <tr key={index} className={pts?.notes && pts?.notes?.length > 0 ? 'coloredRow' : 'reddishRow'}>
                            <td><Link to={{ pathname: "/patientProfile", state: {patientid: pts?.assigned_patient_id?._id}}} className="link">{pts?.assigned_patient_id?.lastname +" , "+ pts?.assigned_patient_id?.firstname } </Link> </td>
                            {calcSysBpCategory(pts?.telemetaryData?.sys)}
                            <td> {
                                pts?.telemetaryData?.sys >= 139 || pts?.telemetaryData?.sys <= 110 ? 
                                <span style={{color: 'red', fontWeight: 'bold'}}>{pts?.telemetaryData?.sys}</span> : 
                                <span>{pts?.telemetaryData?.sys}</span>} &nbsp; / &nbsp; 
                                {pts?.telemetaryData?.dia >= 90 || pts?.telemetaryData?.dia <= 70 ? 
                                <span style={{color: 'red', fontWeight: 'bold'}}>{pts?.telemetaryData?.dia}</span> : 
                                <span>{pts?.telemetaryData?.dia}</span>}
                            </td>
                            <td>{pts?.telemetaryData?.pul}</td>

                            <td>{formatDateTime(pts?.telemetaryData?.ts * 1000)}</td>
                            
                            <td style={{color: color, textAlign: 'center'}}>
                                <i className='bx bxs-circle' style={{fontSize: '18px'}}></i> &nbsp; {sysBPCategory}
                            </td>
                           
                            <td>
                            {pts?.notes?.length > 0 ? <i className="fas fa-check" style={{color: 'green'}}></i> : 
                                <i className="fas fa-times" style={{color: 'red'}}></i>}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </div>
        )
    }

export default PatientsWithCriticalReadingsAdmin